/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import { FC, useMemo, useState } from 'react';

import Link from 'next/link';

import { useTheme } from 'styled-components';
import { usePrivateLayout } from '~/layouts/private/providers/privateLayout';

import { formatFriendlyDate } from '~/common/utils/format-friendly-date';
import { useAuth } from '~/common/providers/auth';
import { SPACING } from '~/common/layout-propertis/spacing';
import { IAugustoPost } from '~/common/interfaces/IAugustoPost';
import { UserSubscriptionTypes } from '~/common/enums/UserSubscriptionTypes';
import { Typography } from '~/common/components/Typography';
import { IconButton } from '~/common/components/IconButton';
import { GenericMenuItem } from '~/common/components/GenericMenuItem';
import { Above } from '~/common/components/Above';

import { Content, PostContainer } from './styles';
import augusto from '../../../../../../public/images/augusto.jpeg';

interface IAugustoPostProps {
  post: IAugustoPost;
  onlyContent?: boolean;
  edit?: (post: IAugustoPost) => void;
  remove?: (id: number) => void;
}
export const AugustoPost: FC<IAugustoPostProps> = ({
  post,
  onlyContent = false,
  edit,
  remove,
}) => {
  const { isMobile } = usePrivateLayout();
  const theme = useTheme();
  const [confirmDelete, setConfirmDelete] = useState<number>();
  const {
    user: { subscription: userType },
  } = useAuth();

  const renderButtons = useMemo(() => {
    return userType === UserSubscriptionTypes.admin && !!edit && !!remove;
  }, [userType, edit, remove]);

  return (
    <PostContainer>
      {!onlyContent && (
        <img
          src={augusto.src}
          alt=""
          style={{ width: '50px', height: '50px', borderRadius: '50%' }}
        />
      )}

      <Content>
        {!onlyContent && (
          <header>
            <Typography.Label
              size="small"
              color="neutral.0"
              style={{ fontWeight: 'bold' }}
            >
              Augusto Backes
            </Typography.Label>

            {!isMobile && (
              <Typography.Label size="small" color="neutral.200">
                -
              </Typography.Label>
            )}

            <Typography.Label size="small" color="neutral.200">
              {formatFriendlyDate(new Date(post?.createdAt))}
            </Typography.Label>
            {renderButtons && (
              <div
                id="right"
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: SPACING._8,
                }}
              >
                <IconButton
                  small
                  icon="pencil-line"
                  backgroundColor={theme.neutral[900]}
                  textOrIconColor={theme.green[500]}
                  borderColor={theme.transparent}
                  onClick={() => edit(post)}
                />

                <div style={{ position: 'relative' }}>
                  <IconButton
                    small
                    icon="delete-bin-line"
                    backgroundColor={theme.neutral[900]}
                    textOrIconColor={theme.red[500]}
                    borderColor={theme.transparent}
                    onClick={() => setConfirmDelete(post.id)}
                  />

                  <Above.Popover
                    withoutPadding
                    background="neutral.950"
                    arrowPosition="top"
                    close={() => setConfirmDelete(null)}
                    open={!!confirmDelete}
                    orientation="vertical"
                    positioning={{
                      left: '-45px',
                      bottom: '-10px',
                    }}
                  >
                    <GenericMenuItem
                      title="Confirmar exclusão"
                      index={2}
                      selected={false}
                      transparentBackground
                      id="confirm-delete-post"
                      onClick={() => {
                        setConfirmDelete(null);
                        remove(post.id);
                      }}
                    />
                  </Above.Popover>
                </div>
              </div>
            )}
          </header>
        )}

        <Typography.Paragraph
          size="small"
          color="neutral.200"
          style={{
            whiteSpace: 'pre-wrap',
          }}
        >
          {post?.text}
        </Typography.Paragraph>

        {post?.imageUrl && (
          <Link
            href={post.imageUrl}
            style={{ cursor: 'pointer' }}
            target="_blank"
          >
            <img src={post.imageUrl} />
          </Link>
        )}
      </Content>
    </PostContainer>
  );
};
